import api from './api';
import { isArrayResponse, withMockFallback } from '@/utils/queryMock';

export interface GoldPriceDTO {
  type: string;
  buy: number;
  sell: number;
  updatedAt: string;
  overrideApplied?: boolean;
}

type GoldPriceApiResponse =
  | GoldPriceDTO[]
  | { data?: GoldPriceDTO[]; items?: GoldPriceDTO[]; prices?: GoldPriceDTO[] };

function normalizeGoldPrices(payload: GoldPriceApiResponse): GoldPriceDTO[] {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload.data)) return payload.data;
  if (Array.isArray(payload.items)) return payload.items;
  if (Array.isArray(payload.prices)) return payload.prices;
  return [];
}

async function mockGoldPrices(): Promise<GoldPriceDTO[]> {
  const now = new Date().toISOString();
  // Jitter nhẹ để UI thấy cập nhật động
  const jitter = () => Math.round((Math.random() - 0.5) * 100_000);
  return [
    { type: 'SJC 9999', buy: 118_400_000 + jitter(), sell: 118_700_000 + jitter(), updatedAt: now },
    { type: '24K', buy: 116_800_000 + jitter(), sell: 117_100_000 + jitter(), updatedAt: now },
    { type: '18K', buy: 87_200_000 + jitter(), sell: 87_500_000 + jitter(), updatedAt: now },
    { type: '14K', buy: 67_800_000 + jitter(), sell: 68_100_000 + jitter(), updatedAt: now },
  ];
}

export const goldPriceService = {
  getCurrent: (): Promise<GoldPriceDTO[]> =>
    withMockFallback(
      async () => {
        const res = await api.get<GoldPriceApiResponse>('/gold-prices/current');
        return normalizeGoldPrices(res.data);
      },
      mockGoldPrices,
      { label: 'gold-prices.current', validate: isArrayResponse },
    ),
};

// Polling helper — returns cleanup fn
export function startGoldPricePoll(
  //dispatch: (prices: GoldPriceDTO[]) => void,
  intervalMs = 30_000,
): () => void {
  const tick = async () => {
    try {
      //const prices = await goldPriceService.getCurrent();
      //dispatch(prices);
    } catch {
      // silent fail — stale price stays in Redux
    }
  };

  tick();
  const id = setInterval(tick, intervalMs);
  return () => clearInterval(id);
}
